"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchRequestFaultDetailsByRowKeyAction = exports.dispatchRequestFaultDetailsAction = exports.faultsRemoveFlagAction = exports.faultsAddFlagAction = exports.faultsSetIsResolvedViewAction = exports.faultsAddOrRemoveFaultToResolveAction = exports.faultsHandleResolveFaultsAction = exports.faultsSetFaultsInboxIsLoadingAction = exports.faultsSetFaultDetailsErrorAction = exports.FAULTS_SET_FAULT_DETAILS_ERROR = exports.FAULTS_SET_SELECTED_FAULT_FOR_DETAILS_MODAL = exports.FAULTS_SET_INBOX_IS_LOADING = exports.FAULTS_HANDLE_RESOLVE_FAULTS_ACTION = exports.FAULTS_ADD_OR_REMOVE_FAULT_TO_RESOLVE = exports.FAULTS_SET_IS_RESOLVED_VIEW = exports.FAULTS_GOT_INBOX_DATA_CSV = exports.FAULTS_NEEDS_INBOX_DATA_CSV = exports.FAULTS_NEEDS_INBOX_DATA_BY_DATE_RANGE = exports.FAULTS_SET_MORE_FILTERS = exports.FAULTS_SET_SEVERITY_FILTERS = exports.FAULTS_GOT_INBOX_DATA_ERROR = exports.FAULTS_GOT_MORE_INBOX_DATA = exports.FAULTS_NEEDS_MORE_INBOX_DATA = exports.FAULTS_GOT_INBOX_DATA = exports.FAULTS_NEEDS_INBOX_DATA = exports.FAULTS_RECEIVE_DEALERS_DATA = exports.FAULTS_REQUEST_DEALERS_DATA = exports.FAULT_DESCRIPTIONS_ERROR = exports.FAULTS_TOGGLE_IS_RESOLVED_ERROR = exports.FAULTS_TOGGLE_IS_RESOLVED_SUCCESS = exports.FAULTS_TOGGLE_IS_RESOLVED = exports.FAULTS_REQUEST_TOGGLE_IS_RESOLVED = exports.FAULTS_CONFIRM_REQUEST_TOGGLE_IS_RESOLVED = exports.FAULTS_REQUEST_RESOLVE_ALL_CHECKED_FAULTS = exports.FAULTS_RECEIVE_FAULT_DESCRIPTIONS = exports.FAULTS_RING_BUFFER_DATA_ERROR = exports.FAULTS_RECIEVE_FAULT_RING_BUFFER_DATA = exports.FAULTS_REQUEST_FAULT_RING_BUFFER_DATA = exports.FAULT_DETAILS_ERROR = exports.FAULTS_RECEIVE_FAULT_DETAILS = exports.FAULTS_REQUEST_FAULT_DETAILS_BY_STREAMING_SOURCE_AND_ID = exports.FAULTS_REQUEST_FAULT_DETAILS_BY_ROW_KEY = exports.FAULTS_REQUEST_FAULT_DETAILS = exports.FAULTS_FLAG_REMOVED_ACTION = exports.FAULTS_REMOVE_FLAG_ERROR_ACTION = exports.FAULTS_REMOVE_FLAG_ACTION = exports.FAULTS_FLAG_ADDED_ACTION = exports.FAULTS_ADD_FLAG_ERROR_ACTION = exports.FAULTS_ADD_FLAG_ACTION = exports.FAULTS_GOT_FLAGS_ACTION = void 0;
exports.faultsReducer = exports.faultsSetSelectedFaultForDetailsModalAction = exports.dispatchGotFaultsInboxCsv = exports.dispatchExportFaultsInboxCsv = exports.dispatchFaultInboxSelectDateRangeAction = exports.setFaultInboxMoreFilters = exports.dispatchSetFaultInboxFilters = exports.dispatchFaultGotInboxDataError = exports.dispatchFaultGotMoreInboxData = exports.dispatchFaultNeedsMoreInboxData = exports.dispatchFaultGotInboxData = exports.dispatchFaultsGotFlagsAction = exports.dispatchFaultNeedsInboxData = exports.dispatchToggleFaultIsResolvedError = exports.dispatchToggleFaultIsResolvedSuccess = exports.dispatchConfirmRequestToggleFaultIsResolved = exports.dispatchRequestToggleFaultIsResolved = exports.dispatchToggleFaultIsResolved = exports.dispatchRequestResolveAllCheckedFaults = exports.dispatchReceiveFaultDescriptionsAction = exports.dispatchRequestRingBufferDataAction = exports.dispatchFaultsErrorAction = exports.dispatchReceiveFaultDetailsAction = exports.dispatchRequestFaultDetailsByStreamingSourceAndIdAction = void 0;
var faults_model_1 = require("../models/faults.model");
// Actions
exports.FAULTS_GOT_FLAGS_ACTION = 'FAULTS_GOT_FLAGS_ACTION';
exports.FAULTS_ADD_FLAG_ACTION = 'FAULTS_ADD_FLAG_ACTION';
exports.FAULTS_ADD_FLAG_ERROR_ACTION = 'FAULTS_ADD_FLAG_ERROR_ACTION';
exports.FAULTS_FLAG_ADDED_ACTION = 'FAULTS_FLAG_ADDED_ACTION';
exports.FAULTS_REMOVE_FLAG_ACTION = 'FAULTS_REMOVE_FLAG_ACTION';
exports.FAULTS_REMOVE_FLAG_ERROR_ACTION = 'FAULTS_REMOVE_FLAG_ERROR_ACTION';
exports.FAULTS_FLAG_REMOVED_ACTION = 'FAULTS_FLAG_REMOVED_ACTION';
exports.FAULTS_REQUEST_FAULT_DETAILS = 'FAULTS_REQUEST_FAULT_DETAILS';
/** @deprecated use FAULTS_REQUEST_FAULT_DETAILS_BY_STREAMING_SOURCE_AND_ID */
exports.FAULTS_REQUEST_FAULT_DETAILS_BY_ROW_KEY = 'FAULTS_REQUEST_FAULT_DETAILS_BY_ROW_KEY';
exports.FAULTS_REQUEST_FAULT_DETAILS_BY_STREAMING_SOURCE_AND_ID = 'FAULTS_REQUEST_FAULT_DETAILS_BY_STREAMING_SOURCE_AND_ID';
exports.FAULTS_RECEIVE_FAULT_DETAILS = 'FAULTS_RECEIVE_FAULT_DETAILS';
exports.FAULT_DETAILS_ERROR = 'FAULT_DETAILS_ERROR';
exports.FAULTS_REQUEST_FAULT_RING_BUFFER_DATA = 'FAULTS_REQUEST_FAULT_RING_BUFFER_DATA';
exports.FAULTS_RECIEVE_FAULT_RING_BUFFER_DATA = 'FAULTS_RECIEVE_FAULT_RING_BUFFER_DATA';
exports.FAULTS_RING_BUFFER_DATA_ERROR = 'FAULTS_RING_BUFFER_DATA_ERROR';
exports.FAULTS_RECEIVE_FAULT_DESCRIPTIONS = 'FAULTS_RECEIVE_FAULT_DESCRIPTIONS';
exports.FAULTS_REQUEST_RESOLVE_ALL_CHECKED_FAULTS = 'FAULTS_REQUEST_RESOLVE_ALL_CHECKED_FAULTS';
exports.FAULTS_CONFIRM_REQUEST_TOGGLE_IS_RESOLVED = 'FAULTS_CONFIRM_REQUEST_TOGGLE_IS_RESOLVED';
exports.FAULTS_REQUEST_TOGGLE_IS_RESOLVED = 'FAULTS_REQUEST_TOGGLE_IS_RESOLVED';
exports.FAULTS_TOGGLE_IS_RESOLVED = 'FAULTS_TOGGLE_IS_RESOLVED';
exports.FAULTS_TOGGLE_IS_RESOLVED_SUCCESS = 'FAULTS_TOGGLE_IS_RESOLVED_SUCCESS';
exports.FAULTS_TOGGLE_IS_RESOLVED_ERROR = 'FAULTS_TOGGLE_IS_RESOLVED_ERROR';
exports.FAULT_DESCRIPTIONS_ERROR = 'FAULT_DESCRIPTIONS_ERROR';
exports.FAULTS_REQUEST_DEALERS_DATA = 'FAULTS_REQUEST_DEALERS_DATA';
exports.FAULTS_RECEIVE_DEALERS_DATA = 'FAULTS_RECEIVE_DEALERS_DATA';
exports.FAULTS_NEEDS_INBOX_DATA = 'FAULTS_NEEDS_INBOX_DATA';
exports.FAULTS_GOT_INBOX_DATA = 'FAULTS_GOT_INBOX_DATA';
exports.FAULTS_NEEDS_MORE_INBOX_DATA = 'FAULTS_NEEDS_MORE_INBOX_DATA';
exports.FAULTS_GOT_MORE_INBOX_DATA = 'FAULTS_GOT_MORE_INBOX_DATA';
exports.FAULTS_GOT_INBOX_DATA_ERROR = 'FAULTS_GOT_INBOX_DATA_ERROR';
exports.FAULTS_SET_SEVERITY_FILTERS = 'FAULTS_SET_SEVERITY_FILTERS';
exports.FAULTS_SET_MORE_FILTERS = 'FAULTS_SET_MORE_FILTERS';
exports.FAULTS_NEEDS_INBOX_DATA_BY_DATE_RANGE = 'FAULTS_NEEDS_INBOX_DATA_BY_DATE_RANGE';
exports.FAULTS_NEEDS_INBOX_DATA_CSV = 'FAULTS_NEEDS_INBOX_DATA_CSV';
exports.FAULTS_GOT_INBOX_DATA_CSV = 'FAULTS_GOT_INBOX_DATA_CSV';
exports.FAULTS_SET_IS_RESOLVED_VIEW = 'FAULTS_SET_IS_RESOLVED_VIEW';
exports.FAULTS_ADD_OR_REMOVE_FAULT_TO_RESOLVE = 'FAULTS_ADD_FAULT_TO_RESOLVE';
exports.FAULTS_HANDLE_RESOLVE_FAULTS_ACTION = 'FAULTS_HANDLE_RESOLVE_FAULTS_ACTION';
exports.FAULTS_SET_INBOX_IS_LOADING = 'FAULTS_SET_INBOX_IS_LOADING';
exports.FAULTS_SET_SELECTED_FAULT_FOR_DETAILS_MODAL = 'FAULTS_SET_SELECTED_FAULT_FOR_DETAILS_MODAL';
exports.FAULTS_SET_FAULT_DETAILS_ERROR = 'FAULTS_SET_FAULT_DETAILS_ERROR';
// Action Dispatchers
var faultsSetFaultDetailsErrorAction = function (faultDetailsError) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_SET_FAULT_DETAILS_ERROR,
    payload: { faultDetailsError: faultDetailsError },
}); }; };
exports.faultsSetFaultDetailsErrorAction = faultsSetFaultDetailsErrorAction;
var faultsSetFaultsInboxIsLoadingAction = function (faultInboxLoading) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_SET_INBOX_IS_LOADING,
    payload: { faultInboxLoading: faultInboxLoading },
}); }; };
exports.faultsSetFaultsInboxIsLoadingAction = faultsSetFaultsInboxIsLoadingAction;
var faultsHandleResolveFaultsAction = function (resolving) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_HANDLE_RESOLVE_FAULTS_ACTION,
    payload: { resolving: resolving },
}); }; };
exports.faultsHandleResolveFaultsAction = faultsHandleResolveFaultsAction;
var faultsAddOrRemoveFaultToResolveAction = function (fault) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_ADD_OR_REMOVE_FAULT_TO_RESOLVE,
    payload: {
        fault: fault,
    },
}); }; };
exports.faultsAddOrRemoveFaultToResolveAction = faultsAddOrRemoveFaultToResolveAction;
var faultsSetIsResolvedViewAction = function (isResolvedView) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_SET_IS_RESOLVED_VIEW,
    payload: { isResolvedView: isResolvedView },
}); }; };
exports.faultsSetIsResolvedViewAction = faultsSetIsResolvedViewAction;
/** Dispatch to add a flag when a fault without a flag is clicked */
var faultsAddFlagAction = function (faultId, rowKey) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_ADD_FLAG_ACTION,
    payload: { faultId: faultId, rowKey: rowKey },
}); }; };
exports.faultsAddFlagAction = faultsAddFlagAction;
/** Dispatch to remove a flag when a fault with a flag is clicked */
var faultsRemoveFlagAction = function (faultId) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_REMOVE_FLAG_ACTION,
    payload: { faultId: faultId },
}); }; };
exports.faultsRemoveFlagAction = faultsRemoveFlagAction;
var dispatchRequestFaultDetailsAction = function (rowKey) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_REQUEST_FAULT_DETAILS,
    payload: rowKey,
}); }; };
exports.dispatchRequestFaultDetailsAction = dispatchRequestFaultDetailsAction;
/** @deprecated use dispatchRequestFaultDetailsByStreamingSourceAndIdAction */
var dispatchRequestFaultDetailsByRowKeyAction = function (rowKey) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_REQUEST_FAULT_DETAILS_BY_ROW_KEY,
    payload: rowKey,
}); }; };
exports.dispatchRequestFaultDetailsByRowKeyAction = dispatchRequestFaultDetailsByRowKeyAction;
var dispatchRequestFaultDetailsByStreamingSourceAndIdAction = function (streamingSource, id) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_REQUEST_FAULT_DETAILS_BY_STREAMING_SOURCE_AND_ID,
    payload: { streamingSource: streamingSource, id: id },
}); }; };
exports.dispatchRequestFaultDetailsByStreamingSourceAndIdAction = dispatchRequestFaultDetailsByStreamingSourceAndIdAction;
var dispatchReceiveFaultDetailsAction = function (data) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_RECEIVE_FAULT_DETAILS,
    payload: data,
}); }; };
exports.dispatchReceiveFaultDetailsAction = dispatchReceiveFaultDetailsAction;
var dispatchFaultsErrorAction = function (error) { return function (dispatch) { return dispatch({
    type: exports.FAULT_DETAILS_ERROR,
    payload: error,
}); }; };
exports.dispatchFaultsErrorAction = dispatchFaultsErrorAction;
var dispatchRequestRingBufferDataAction = function (faultId) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_REQUEST_FAULT_RING_BUFFER_DATA,
    payload: faultId,
}); }; };
exports.dispatchRequestRingBufferDataAction = dispatchRequestRingBufferDataAction;
var dispatchReceiveFaultDescriptionsAction = function (data) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_RECEIVE_FAULT_DESCRIPTIONS,
    payload: data,
}); }; };
exports.dispatchReceiveFaultDescriptionsAction = dispatchReceiveFaultDescriptionsAction;
var dispatchRequestResolveAllCheckedFaults = function () { return function (dispatch) {
    dispatch({
        type: exports.FAULTS_REQUEST_RESOLVE_ALL_CHECKED_FAULTS,
    });
}; };
exports.dispatchRequestResolveAllCheckedFaults = dispatchRequestResolveAllCheckedFaults;
var dispatchToggleFaultIsResolved = function (fault) { return function (dispatch) {
    dispatch({
        type: exports.FAULTS_TOGGLE_IS_RESOLVED,
        payload: {
            fault: __assign(__assign({}, fault), { isResolved: !fault.isResolved }),
        },
    });
}; };
exports.dispatchToggleFaultIsResolved = dispatchToggleFaultIsResolved;
var dispatchRequestToggleFaultIsResolved = function (fault, isResolved) { return function (dispatch) {
    dispatch({
        type: exports.FAULTS_REQUEST_TOGGLE_IS_RESOLVED,
        payload: __assign(__assign({}, fault), { isResolved: isResolved }),
    });
}; };
exports.dispatchRequestToggleFaultIsResolved = dispatchRequestToggleFaultIsResolved;
var dispatchConfirmRequestToggleFaultIsResolved = function () { return function (dispatch) {
    dispatch({
        type: exports.FAULTS_CONFIRM_REQUEST_TOGGLE_IS_RESOLVED,
    });
}; };
exports.dispatchConfirmRequestToggleFaultIsResolved = dispatchConfirmRequestToggleFaultIsResolved;
var dispatchToggleFaultIsResolvedSuccess = function (fault) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_TOGGLE_IS_RESOLVED_SUCCESS,
    payload: fault,
}); }; };
exports.dispatchToggleFaultIsResolvedSuccess = dispatchToggleFaultIsResolvedSuccess;
var dispatchToggleFaultIsResolvedError = function (error) { return function (dispatch) {
    dispatch({
        type: exports.FAULTS_TOGGLE_IS_RESOLVED_ERROR,
        payload: error,
    });
}; };
exports.dispatchToggleFaultIsResolvedError = dispatchToggleFaultIsResolvedError;
var dispatchFaultNeedsInboxData = function (pagingData) { return function (dispatch) {
    dispatch({
        type: exports.FAULTS_NEEDS_INBOX_DATA,
        payload: { pagingData: pagingData },
        meta: {
            debounce: {
                time: 1000,
            },
        },
    });
}; };
exports.dispatchFaultNeedsInboxData = dispatchFaultNeedsInboxData;
var dispatchFaultsGotFlagsAction = function (flagsResponse) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_GOT_FLAGS_ACTION,
    payload: { flags: __assign({}, flagsResponse) },
}); }; };
exports.dispatchFaultsGotFlagsAction = dispatchFaultsGotFlagsAction;
var dispatchFaultGotInboxData = function (data) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_GOT_INBOX_DATA,
    payload: { data: data },
}); }; };
exports.dispatchFaultGotInboxData = dispatchFaultGotInboxData;
var dispatchFaultNeedsMoreInboxData = function (pagingData) { return function (dispatch) {
    dispatch({
        type: exports.FAULTS_NEEDS_MORE_INBOX_DATA,
        payload: { pagingData: pagingData },
    });
}; };
exports.dispatchFaultNeedsMoreInboxData = dispatchFaultNeedsMoreInboxData;
var dispatchFaultGotMoreInboxData = function (data) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_GOT_MORE_INBOX_DATA,
    payload: { data: data },
}); }; };
exports.dispatchFaultGotMoreInboxData = dispatchFaultGotMoreInboxData;
var dispatchFaultGotInboxDataError = function (error) { return function (dispatch) {
    dispatch({
        type: exports.FAULTS_GOT_INBOX_DATA_ERROR,
        payload: { error: error },
    });
}; };
exports.dispatchFaultGotInboxDataError = dispatchFaultGotInboxDataError;
var dispatchSetFaultInboxFilters = function (severityFilters) { return function (dispatch) {
    dispatch({
        payload: {
            severityFilters: severityFilters,
        },
        type: exports.FAULTS_SET_SEVERITY_FILTERS,
    });
}; };
exports.dispatchSetFaultInboxFilters = dispatchSetFaultInboxFilters;
var setFaultInboxMoreFilters = function (moreFilters) { return function (dispatch) {
    dispatch({
        payload: {
            moreFilters: moreFilters,
        },
        type: exports.FAULTS_SET_MORE_FILTERS,
    });
}; };
exports.setFaultInboxMoreFilters = setFaultInboxMoreFilters;
var dispatchFaultInboxSelectDateRangeAction = function (dateRange) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_NEEDS_INBOX_DATA_BY_DATE_RANGE,
    payload: { dateRange: dateRange },
}); }; };
exports.dispatchFaultInboxSelectDateRangeAction = dispatchFaultInboxSelectDateRangeAction;
var dispatchExportFaultsInboxCsv = function (isResolved) {
    if (isResolved === void 0) { isResolved = false; }
    return function (dispatch) { return dispatch({
        type: exports.FAULTS_NEEDS_INBOX_DATA_CSV,
        payload: { isResolved: isResolved },
    }); };
};
exports.dispatchExportFaultsInboxCsv = dispatchExportFaultsInboxCsv;
var dispatchGotFaultsInboxCsv = function () { return function (dispatch) { return dispatch({
    type: exports.FAULTS_GOT_INBOX_DATA_CSV,
}); }; };
exports.dispatchGotFaultsInboxCsv = dispatchGotFaultsInboxCsv;
var faultsSetSelectedFaultForDetailsModalAction = function (fault) { return function (dispatch) { return dispatch({
    type: exports.FAULTS_SET_SELECTED_FAULT_FOR_DETAILS_MODAL,
    payload: { fault: fault },
}); }; };
exports.faultsSetSelectedFaultForDetailsModalAction = faultsSetSelectedFaultForDetailsModalAction;
// Reducer
// eslint-disable-next-line default-param-last
var faultsReducer = function (state, action) {
    var _a, _b, _c, _d;
    if (state === void 0) { state = (0, faults_model_1.faultsStateFactory)(); }
    switch (action.type) {
        case exports.FAULTS_SET_FAULT_DETAILS_ERROR: return __assign(__assign({}, state), { faultDetailsError: action.payload.faultDetailsError });
        case exports.FAULTS_GOT_FLAGS_ACTION:
            return __assign(__assign({}, state), { flags: __assign({}, action.payload.flags) });
        case exports.FAULTS_ADD_FLAG_ACTION:
            return __assign(__assign({}, state), { pendingFlagOperations: __spreadArray(__spreadArray([], state.pendingFlagOperations, true), [
                    action.payload.faultId,
                ], false) });
        case exports.FAULTS_FLAG_ADDED_ACTION:
            return __assign(__assign({}, state), { pendingFlagOperations: state.pendingFlagOperations.filter(function (faultId) { return faultId !== action.payload.faultId; }), flags: __assign(__assign({}, state.flags), (_a = {}, _a[action.payload.faultId] = action.payload.flag, _a)) });
        case exports.FAULTS_ADD_FLAG_ERROR_ACTION:
        case exports.FAULTS_REMOVE_FLAG_ERROR_ACTION:
            return __assign(__assign({}, state), { pendingFlagOperations: state.pendingFlagOperations.filter(function (faultId) { return faultId !== action.payload.faultId; }), flaggingErrors: __assign(__assign({}, state.flaggingErrors), (_b = {}, _b[action.payload.faultId] = __spreadArray(__spreadArray([], state.flaggingErrors[action.payload.faultId] || [], true), [action.payload.error], false), _b)) });
        case exports.FAULTS_REMOVE_FLAG_ACTION:
            return __assign(__assign({}, state), { pendingFlagOperations: __spreadArray(__spreadArray([], state.pendingFlagOperations, true), [
                    action.payload.faultId,
                ], false) });
        case exports.FAULTS_FLAG_REMOVED_ACTION: {
            var newFlags = __assign({}, state.flags);
            delete newFlags[action.payload.faultId];
            return __assign(__assign({}, state), { pendingFlagOperations: state.pendingFlagOperations.filter(function (faultId) { return faultId !== action.payload.faultId; }), flags: newFlags });
        }
        case exports.FAULTS_REQUEST_FAULT_DETAILS:
            return __assign(__assign({}, state), { isLoadingFaultDetails: true, faultDetailsError: false });
        case exports.FAULTS_RECEIVE_FAULT_DETAILS:
            return __assign(__assign({}, state), { isLoadingFaultDetails: false, faultDetails: __assign(__assign({}, state.faultDetails), (_c = {}, _c[action.payload.eventId] = __assign({}, action.payload), _c)) });
        case exports.FAULT_DETAILS_ERROR:
            return __assign(__assign({}, state), { isLoadingFaultDetails: false, faultDetailsError: true });
        case exports.FAULTS_REQUEST_FAULT_RING_BUFFER_DATA:
            return __assign(__assign({}, state), { isLoadingRingBufferData: true });
        case exports.FAULTS_RECIEVE_FAULT_RING_BUFFER_DATA:
            return __assign(__assign({}, state), { isLoadingRingBufferData: false, ringBufferData: __assign(__assign({}, state.ringBufferData), action.payload) });
        case exports.FAULTS_RECEIVE_FAULT_DESCRIPTIONS:
            return __assign(__assign({}, state), { isLoadingFaultDescriptions: false, faultDescriptions: __assign(__assign({}, state.faultDescriptions), action.payload) });
        case exports.FAULT_DESCRIPTIONS_ERROR:
            return __assign(__assign({}, state), { faultDescriptionsError: true, isLoadingFaultDescriptions: false });
        case exports.FAULTS_RING_BUFFER_DATA_ERROR:
            return __assign(__assign({}, state), { ringBufferDataError: true });
        case exports.FAULTS_REQUEST_TOGGLE_IS_RESOLVED:
            return __assign(__assign({}, state), { isLoadingToggleIsResolved: true, toggleIsResolvedError: false });
        case exports.FAULTS_TOGGLE_IS_RESOLVED_SUCCESS: {
            var faultDetails = state.faultDetails;
            var eventId = action.payload.eventId;
            return __assign(__assign({}, state), { isLoadingToggleIsResolved: false, toggleIsResolvedError: false, faultDetails: __assign(__assign({}, faultDetails), (_d = {}, _d[eventId] = __assign(__assign({}, faultDetails[eventId]), { isResolved: action.payload.isResolved }), _d)) });
        }
        case exports.FAULTS_TOGGLE_IS_RESOLVED_ERROR:
            return __assign(__assign({}, state), { isLoadingToggleIsResolved: false, toggleIsResolvedError: true });
        case exports.FAULTS_NEEDS_INBOX_DATA:
            return __assign(__assign({}, state), { faultInbox: [], faultInboxPaging: action.payload.pagingData });
        case exports.FAULTS_GOT_INBOX_DATA:
            return __assign(__assign({}, state), { faultInbox: action.payload.data.Data, faultInboxPaging: action.payload.data.Paging });
        case exports.FAULTS_NEEDS_MORE_INBOX_DATA:
            return __assign(__assign({}, state), { faultInboxLoading: true, faultInboxPaging: action.payload.pagingData });
        case exports.FAULTS_GOT_MORE_INBOX_DATA:
            return __assign(__assign({}, state), { faultInbox: state.faultInbox.concat(action.payload.data.Data), faultInboxPaging: action.payload.data.Paging, faultInboxLoading: false });
        case exports.FAULTS_GOT_INBOX_DATA_ERROR:
            return __assign(__assign({}, state), { faultInboxLoading: false, faultInboxLoadingError: !!action.payload.error });
        case exports.FAULTS_SET_SEVERITY_FILTERS:
            return __assign(__assign({}, state), { faultFilters: action.payload.severityFilters });
        case exports.FAULTS_NEEDS_INBOX_DATA_BY_DATE_RANGE:
            return __assign(__assign({}, state), { dateRange: action.payload.dateRange });
        case exports.FAULTS_NEEDS_INBOX_DATA_CSV:
            return __assign(__assign({}, state), { isDownloadingCsv: true });
        case exports.FAULTS_GOT_INBOX_DATA_CSV:
            return __assign(__assign({}, state), { isDownloadingCsv: false });
        case exports.FAULTS_SET_IS_RESOLVED_VIEW:
            return __assign(__assign({}, state), { isResolvedView: action.payload.isResolvedView });
        case exports.FAULTS_SET_INBOX_IS_LOADING:
            return __assign(__assign({}, state), { faultInboxLoading: action.payload.faultInboxLoading });
        case exports.FAULTS_SET_SELECTED_FAULT_FOR_DETAILS_MODAL:
            return __assign(__assign({}, state), { selectedFaultForDetailsModal: action.payload.fault });
        default: return state;
    }
};
exports.faultsReducer = faultsReducer;
exports.default = exports.faultsReducer;
